import { createApp, defineAsyncComponent } from 'vue';
import { i18n } from '../../setup/i18n';

export default function init() {
    const app = createApp({});
    app.use(i18n)
        .component(
            'ProductOrderingCodes',
            defineAsyncComponent(() => import('./ProductOrderingCodes.vue'))
        )
        .mount('#app-product-ordering-codes');
}
